import { useSelector } from 'react-redux';
import { PapiDeviation, PapiGallection } from '@wix/da-papi-types';
import { getEnv } from '@wix/da-react-app/pkg/client/Environment/redux/selectors';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { getFolderById } from '../../../../../selectors/folders';
import { isCurrentUserProfileOwner } from '../../../../../selectors/users';
import {
  getGallectionSectionType,
  getSelectedSubfolder,
} from '../../../../../selectors/gallectionSection';
import { getCurrentPage, getTotalPages } from '../../../../../selectors/pageInfo';
import { getFolderDeviationsStreamId } from '../../../../../streams/folderDeviations';
import { GallectionType } from '../../../../../../types/gallection';
import { AppState } from '../../../../../../types/store';

export interface UsePagedFolderDeviationsReturn {
  currentPage: number;
  deviations: PapiDeviation[];
  folder?: PapiGallection;
  subfolder?: PapiGallection;
  gallectionType: GallectionType;
  isOwner: boolean;
  requestUrl: string;
  streamId: string;
  totalPages: number;
}

export default function usePagedFolderDeviations(folderId: number): UsePagedFolderDeviationsReturn {
  const gallectionType = useSelector(getGallectionSectionType);
  const selectedSubfolder = useSelector(getSelectedSubfolder);
  const requestUrl = useSelector(state => getEnv(state).requestUrl) ?? '';
  const currentPage = useSelector(getCurrentPage);
  const totalPages = useSelector(getTotalPages);
  const isOwner = useSelector(isCurrentUserProfileOwner);
  const folder = useSelector((state: AppState) => getFolderById(state, gallectionType, folderId));
  const subfolder =
    selectedSubfolder && selectedSubfolder.parentId === folderId ? selectedSubfolder : undefined;
  const currentFolderId = subfolder?.folderId ?? folderId;
  const streamId = getFolderDeviationsStreamId(gallectionType, currentFolderId);
  const deviations = useSelector((state: AppState) =>
    getDeviationsByIds(state, streamSelectors.getItems(state, streamId) || [])
  );

  return {
    currentPage,
    deviations,
    folder,
    subfolder,
    gallectionType,
    isOwner,
    requestUrl,
    streamId,
    totalPages,
  };
}
